module.exports = __webpack_public_path__ + "img/cover-slot-bg.0b5c20e5.jpg";